module.exports = __webpack_public_path__ + "staticVue/img/location-icon.ca3f2899.png";